import axios from "../../../../axios-order";
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import State from "../../../../asserts/jsonData/state.json";
import { toast } from "react-toastify";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Grid, Container, Stack, Typography, Box, styled, Stepper, Step, StepLabel, Button } from "@mui/material";
import { Paper } from "@material-ui/core";
import SelectInput from "../../../../components/ui/basicSelectInput";
import {
    DataGridPro,
} from '@mui/x-data-grid-pro';
import { stepConnectorClasses } from '@mui/material/StepConnector';
import StepConnector from '@mui/material/StepConnector';
import { Check } from "@mui/icons-material";
import AssignmentIcon from '@mui/icons-material/Assignment';
import BallotIcon from '@mui/icons-material/Ballot';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import excelIconImage from '../../../../asserts/images/excelicon.svg'
import BoxWrapper from "../../../../components/ui/boxWrapper";

// Custom styled connector similar to your original design
const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#1976d2',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#1976d2',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#ccc',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

// Custom step icon component
const CustomStepIconRoot = styled('div')(({ theme }) => ({
    color: '#ccc',
    display: 'flex',
    height: 34,
    width: 34,
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '500',
    borderRadius: '50%',
    backgroundColor: '#ccc',
    variants: [
        {
            props: ({ ownerState }) => ownerState.active,
            style: {
                backgroundColor: '#1976d2',
                color: '#fff',
                backgroundImage:
                    'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
                boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            },
        },
        {
            props: ({ ownerState }) => ownerState.completed,
            style: {
                backgroundColor: '#4caf50',
                color: '#fff',
            },
        },
    ],
}));

function CustomStepIcon(props) {
    const { active, completed, className, icon } = props;

    const icons = {
        1: <AssignmentIcon />,
        2: <BallotIcon />,
        3: <CalendarViewMonthIcon />,
    };

    return (
        <CustomStepIconRoot ownerState={{ active, completed }} className={className}>
            {completed ? (
                <Check className="QontoStepIcon-completedIcon" />
            ) : (
                icons[String(props.icon)]
            )}
        </CustomStepIconRoot>
    );
}

// Custom SVG Icons
const CheckIcon = ({ size = 16, color = "#ffffff" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20,6 9,17 4,12"></polyline>
    </svg>
);

const ChevronRightIcon = ({ size = 20, color = "#2563eb" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9,18 15,12 9,6"></polyline>
    </svg>
);

const Form26QFiling = () => {
    const history = useHistory();
    const [activeStep, setActiveStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState(new Set());
    const [errors, setErrors] = useState({});

    const [activeFormStep, setActiveFormStep] = useState(0);
    const steps = ['Form 26Q Details', 'Challan Details', 'Annexure 1'];

    const [challanData, setChallanData] = useState([]);
    const [annexureData, setAnnexureData] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [stateVisible, setStateVisible] = useState("edit");
    const [isEdit, setIsEdit] = useState(0);
    const [taxDeductorData, setTaxDeductorData] = useState({});
    const [fileName, setFileName] = useState("");
    const [CSIfile, setCSIfile] = useState();

    const handleNext = () => {
        setActiveFormStep((prevActiveFormStep) => prevActiveFormStep + 1);
    };

    const handleBack = () => {
        getForm26QData();
        setActiveFormStep((prevActiveFormStep) => prevActiveFormStep - 1);
    };


    /*Form Details Info Started */
    const [employerDetailFormData, setEmployerDetailFormData] = useState({
        quarter: localStorage.getItem('quarter_26Q'),
        tan: '',
        last_tan: '',
        financial_year: localStorage.getItem('financial_year_26Q'),
        assessment_year: '',
        pan: '',
        type_of_deductor: '',
        is_revised_return: false,
        last_deductor_type: '',
        update_deductor_details: '',
        receipt_number_original: '',
        receipt_number_previous: '',
    });

    const [taxDeductionFormData, setTaxDeductionFormData] = useState({
        name: '',
        ministry_department_name: '',
        ministry_department_name_other: '',
        branch_division: '',
        state_name: null,
        ddo_code: '',
        pao_code: '',
        ddo_registration_number: '',
        pao_registration_number: '',
        flat_no: '',
        premises_name: '',
        road_or_street: '',
        area_or_location: '',
        town_or_city: '',
        pin_code: '',
        state: null,
        telephone_no: '',
        telephone_alternative: '',
        email: '',
        email_alternative: '',
        gstn: '',
        has_address_changed: false,
        ao_ain: '',
    });

    const [personFormData, setPersonFormData] = useState({
        responsible_name: '',
        responsible_pan: '',
        responsible_designation: '',
        responsible_flat_no: '',
        responsible_premises_name: '',
        responsible_road_or_street: '',
        responsible_area_or_location: '',
        responsible_town_or_city: '',
        responsible_pin_code: '',
        responsible_state: null,
        responsible_telephone_no: '',
        responsible_telephone_alternative: '',
        responsible_mobile_no: '',
        responsible_email: '',
        responsible_email_alternative: '',
        responsible_address_same: true,
        responsible_address_changed: false,
        responsible_receipt_number: '',
        filed_earlier_period: false,
        previous_statement_number: ''
    });

    useEffect(() => {
        getBusinessEntityDetails().then(() => {
            getForm26QData();
        });
    }, [])


    useEffect(() => {
        ValidatorForm.addValidationRule('isPANDifferent', (value) => {
            if (value && employerDetailFormData.pan) {
                return value.toUpperCase() !== employerDetailFormData.pan.toUpperCase();
            }
            return true;
        });

        return () => {
            ValidatorForm.removeValidationRule('isPANDifferent');
        };
    }, [employerDetailFormData.pan]);

    useEffect(() => {
        if (activeStep === 2) { 
            if (personFormData.responsible_address_same === true) {
                setPersonFormData(prev => ({
                    ...prev,
                    responsible_pan: ''
                }));
            } else {
                const responsiblePan = taxDeductorData.particulars_person_responsible_for_deduction?.pan || '';
                if (responsiblePan && !personFormData.responsible_pan) {
                    setPersonFormData(prev => ({
                        ...prev,
                        responsible_pan: responsiblePan
                    }));
                }
            }
        }
    }, [activeStep, personFormData.responsible_address_same]);

    const getChallanDetails = () => {
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            quarter: localStorage.getItem('quarter_26Q')
        }
        axios.post('/get_tds_challan_details_for_rpu_file', payload)
            .then((res) => {
                console.log("Challan Response ==>" + JSON.stringify(res));
                setChallanData(res.data.records);
            })
            .catch((err) => {
                console.error("Error fetching business entity details:", err);
            }
            );
    }

    const getAnnexureDetails = () => {
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            quarter: localStorage.getItem('quarter_26Q')
        }
        axios.post('/get_tds_challan_details_for_annexure1', payload)
            .then((res) => {
                console.log("Annexure Response ==>" + JSON.stringify(res));
                setAnnexureData(res.data.records);
            })
            .catch((err) => {
                console.error("Error fetching business entity details:", err);
            }
            );
    }


    const getForm26QData = () => {
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            quarter: localStorage.getItem('quarter_26Q')
        }
        axios.post(`/get_form_26q`, payload)
            .then((res) => {
                console.log("Response ==>" + JSON.stringify(res));
                console.log("Status ==>" + res.data.status);
                if (res.data.status === true) {
                    console.log("Comes here for Data");
                    setIsEdit(res.data.data.id);
                    let deductorType = ''
                    if (res.data.data.pan) {
                        const fourthChar2 = res.data.data.pan.charAt(3);
                        if (fourthChar2 === 'C') {
                            deductorType = "Company";
                        } else if (fourthChar2 === 'B') {
                            deductorType = "Body of Individuals";
                        } else if (fourthChar2 === 'F') {
                            deductorType = "Firm";
                        } else if (fourthChar2 === 'P' || fourthChar2 === 'H') {
                            deductorType = "Individual/HUF";
                        }
                    }
                    // Update formData with tan, pan, and csi_file_name from response
                    setEmployerDetailFormData(prevFormData => ({
                        ...prevFormData,
                        quarter: localStorage.getItem('quarter_26Q'),
                        tan: res.data.data.tan || '',
                        last_tan: res.data.data.last_tan || '',
                        financial_year: res.data.data.financial_year || localStorage.getItem('financial_year_26Q'),
                        assessment_year: res.data.data.assessment_year || '',
                        pan: res.data.data.pan || '',
                        type_of_deductor: res.data.data.type_of_deductor || deductorType,
                        is_revised_return: res.data.data.is_revised_return || false,
                        last_deductor_type: res.data.data.last_deductor_type || '',
                        update_deductor_details: res.data.data.update_deductor_details || '',
                        receipt_number_original: res.data.data.receipt_number_original || '',
                        receipt_number_previous: res.data.data.receipt_number_previous || '',
                    }));

                    setTaxDeductionFormData(prevFormData => ({
                        ...prevFormData,
                        name: res.data.data.name || '',
                        ministry_department_name: res.data.data.ministry_department_name || '',
                        ministry_department_name_other: res.data.data.ministry_department_name_other || '',
                        branch_division: res.data.data.branch_division || '',
                        state_name: res.data.data.state_name || '',
                        ddo_code: res.data.data.ddo_code || '',
                        pao_code: res.data.data.pao_code || '',
                        ddo_registration_number: res.data.data.ddo_registration_number || '',
                        pao_registration_number: res.data.data.pao_registration_number || '',
                        flat_no: res.data.data.flat_no || '',
                        premises_name: res.data.data.premises_name || '',
                        road_or_street: res.data.data.road_or_street || '',
                        area_or_location: res.data.data.area_or_location || '',
                        town_or_city: res.data.data.town_or_city || '',
                        pin_code: res.data.data.pin_code || '',
                        state: res.data.data.state || '',
                        telephone_no: res.data.data.telephone_no || '',
                        telephone_alternative: res.data.data.telephone_alternative || '',
                        email: res.data.data.email || '',
                        email_alternative: res.data.data.email_alternative || '',
                        gstn: res.data.data.gstn || '',
                        has_address_changed: res.data.data.has_address_changed || false,
                        ao_ain: res.data.data.ao_ain || ''
                    }));

                    setPersonFormData(prevFormData => ({
                        ...prevFormData,
                        responsible_name: res.data.data.responsible_name || '',
                        responsible_pan: res.data.data.responsible_pan || '',
                        responsible_designation: res.data.data.responsible_designation || '',
                        responsible_flat_no: res.data.data.responsible_flat_no || '',
                        responsible_premises_name: res.data.data.responsible_premises_name || '',
                        responsible_road_or_street: res.data.data.responsible_road_or_street || '',
                        responsible_area_or_location: res.data.data.responsible_area_or_location || '',
                        responsible_town_or_city: res.data.data.responsible_town_or_city || '',
                        responsible_pin_code: res.data.data.responsible_pin_code || '',
                        responsible_state: res.data.data.responsible_state || '',
                        responsible_telephone_no: res.data.data.responsible_telephone_no || '',
                        responsible_telephone_alternative: res.data.data.responsible_telephone_alternative || '',
                        responsible_mobile_no: res.data.data.responsible_mobile_no || '',
                        responsible_email: res.data.data.responsible_email || '',
                        responsible_email_alternative: res.data.data.responsible_email_alternative || '',
                        responsible_address_same: res.data.data.responsible_address_same || true,
                        responsible_address_changed: res.data.data.responsible_address_changed || false,
                        responsible_receipt_number: res.data.data.responsible_receipt_number || false,
                        filed_earlier_period: res.data.data.filed_earlier_period || false,
                        previous_statement_number: res.data.data.previous_statement_number || '',
                    }));

                    // Set the csi_file_name from the API response
                    setFileName(res.data.data.csi_file_name || '');

                    // ✅ FIX: Store the file data with proper prefix for consistency
                    if (res.data.data.csi_file_data) {
                        // If the data doesn't have the prefix, add it
                        const fileData = res.data.data.csi_file_data.startsWith('data:')
                            ? res.data.data.csi_file_data
                            : `data:application/octet-stream;base64,${res.data.data.csi_file_data}`;
                        setCSIfile(fileData);
                    } else {
                        setCSIfile('');
                    }
                } else {
                    console.log("Comes here for no data")
                    updateTaxDeductorData(taxDeductorData);
                }
            })
            .catch((err) => {
                console.error("Error fetching business entity details:", err);
            })
    }


    // const getForm26QData = () => {
    //     const payload = {
    //         business_entity_id: localStorage.getItem('business_entity_id'),
    //         financial_year: localStorage.getItem('financial_year_26Q'),
    //         quarter: localStorage.getItem('quarter_26Q')
    //     }
    //     axios.post(`/get_form_26q`, payload)
    //         .then((res) => {
    //             console.log("Response ==>" + JSON.stringify(res));
    //             console.log("Status ==>" + res.data.status);
    //             if (res.data.status === true) {
    //                 console.log("Comes here for Data");
    //                 setIsEdit(res.data.data.id);
    //                 let deductorType = ''
    //                 if (res.data.data.pan) {
    //                     const fourthChar2 = res.data.data.pan.charAt(3);
    //                     if (fourthChar2 === 'C') {
    //                         deductorType = "Company";
    //                     } else if (fourthChar2 === 'B') {
    //                         deductorType = "Body of Individuals";
    //                     } else if (fourthChar2 === 'F') {
    //                         deductorType = "Firm";
    //                     } else if (fourthChar2 === 'P' || fourthChar2 === 'H') {
    //                         deductorType = "Individual/HUF";
    //                     }
    //                 }
    //                 // Update formData with tan, pan, and csi_file_name from response
    //                 setEmployerDetailFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     quarter: localStorage.getItem('quarter_26Q'),
    //                     tan: res.data.data.tan || '',
    //                     last_tan: res.data.data.last_tan || '',
    //                     financial_year: res.data.data.financial_year || localStorage.getItem('financial_year_26Q'),
    //                     assessment_year: res.data.data.assessment_year || '',
    //                     pan: res.data.data.pan || '',
    //                     type_of_deductor: res.data.data.type_of_deductor || deductorType,
    //                     is_revised_return: res.data.data.is_revised_return || false,
    //                     last_deductor_type: res.data.data.last_deductor_type || '',
    //                     update_deductor_details: res.data.data.update_deductor_details || '',
    //                     receipt_number_original: res.data.data.receipt_number_original || '',
    //                     receipt_number_previous: res.data.data.receipt_number_previous || '',
    //                 }));

    //                 setTaxDeductionFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     name: res.data.data.name || '',
    //                     ministry_department_name: res.data.data.ministry_department_name || '',
    //                     ministry_department_name_other: res.data.data.ministry_department_name_other || '',
    //                     branch_division: res.data.data.branch_division || '',
    //                     state_name: res.data.data.state_name || '',
    //                     ddo_code: res.data.data.ddo_code || '',
    //                     pao_code: res.data.data.pao_code || '',
    //                     ddo_registration_number: res.data.data.ddo_registration_number || '',
    //                     pao_registration_number: res.data.data.pao_registration_number || '',
    //                     flat_no: res.data.data.flat_no || '',
    //                     premises_name: res.data.data.premises_name || '',
    //                     road_or_street: res.data.data.road_or_street || '',
    //                     area_or_location: res.data.data.area_or_location || '',
    //                     town_or_city: res.data.data.town_or_city || '',
    //                     pin_code: res.data.data.pin_code || '',
    //                     state: res.data.data.state || '',
    //                     telephone_no: res.data.data.telephone_no || '',
    //                     telephone_alternative: res.data.data.telephone_alternative || '',
    //                     email: res.data.data.email || '',
    //                     email_alternative: res.data.data.email_alternative || '',
    //                     gstn: res.data.data.gstn || '',
    //                     has_address_changed: res.data.data.has_address_changed || false,
    //                     ao_ain: res.data.data.ao_ain || ''
    //                 }));

    //                 setPersonFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     responsible_name: res.data.data.responsible_name || '',
    //                     responsible_pan: res.data.data.responsible_pan || '',
    //                     responsible_designation: res.data.data.responsible_designation || '',
    //                     responsible_flat_no: res.data.data.responsible_flat_no || '',
    //                     responsible_premises_name: res.data.data.responsible_premises_name || '',
    //                     responsible_road_or_street: res.data.data.responsible_road_or_street || '',
    //                     responsible_area_or_location: res.data.data.responsible_area_or_location || '',
    //                     responsible_town_or_city: res.data.data.responsible_town_or_city || '',
    //                     responsible_pin_code: res.data.data.responsible_pin_code || '',
    //                     responsible_state: res.data.data.responsible_state || '',
    //                     responsible_telephone_no: res.data.data.responsible_telephone_no || '',
    //                     responsible_telephone_alternative: res.data.data.responsible_telephone_alternative || '',
    //                     responsible_mobile_no: res.data.data.responsible_mobile_no || '',
    //                     responsible_email: res.data.data.responsible_email || '',
    //                     responsible_email_alternative: res.data.data.responsible_email_alternative || '',
    //                     responsible_address_same: res.data.data.responsible_address_same || true,
    //                     responsible_address_changed: res.data.data.responsible_address_changed || false,
    //                     responsible_receipt_number: res.data.data.responsible_receipt_number || false,
    //                     filed_earlier_period: res.data.data.filed_earlier_period || false,
    //                 }));

    //                 // Set the csi_file_name from the API response
    //                 setFileName(res.data.data.csi_file_name || '');
    //                 setCSIfile(res.data.data.csi_file_data || '');
    //             } else {
    //                 console.log("Comes here for no data")
    //                 updateTaxDeductorData(taxDeductorData);
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("Error fetching business entity details:", err);
    //         })
    // }

    // const getForm26QData = () => {
    //     const payload = {
    //         business_entity_id: localStorage.getItem('business_entity_id'),
    //         financial_year: localStorage.getItem('financial_year_26Q'),
    //         quarter: localStorage.getItem('quarter_26Q')
    //     }
    //     axios.post(`/get_form_26q`, payload)
    //         .then((res) => {
    //             console.log("Response ==>" + JSON.stringify(res));
    //             console.log("Status ==>" + res.data.status);
    //             if (res.data.status === true) {
    //                 console.log("Comes here for Data");
    //                 setIsEdit(res.data.data.id);
    //                 let deductorType = ''
    //                 if (res.data.data.pan) {
    //                     const fourthChar2 = res.data.data.pan.charAt(3);
    //                     if (fourthChar2 === 'C') {
    //                         deductorType = "Company";
    //                     } else if (fourthChar2 === 'B') {
    //                         deductorType = "Body of Individuals";
    //                     } else if (fourthChar2 === 'F') {
    //                         deductorType = "Firm";
    //                     } else if (fourthChar2 === 'P' || fourthChar2 === 'H') {
    //                         deductorType = "Individual/HUF";
    //                     }
    //                 }
    //                 //Update formData with tan and pan from response
    //                 setEmployerDetailFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     quarter: localStorage.getItem('quarter_26Q'),
    //                     tan: res.data.data.tan || '',
    //                     last_tan: res.data.data.last_tan || '',
    //                     financial_year: res.data.data.financial_year || localStorage.getItem('financial_year_26Q'),
    //                     assessment_year: res.data.data.assessment_year || '',
    //                     pan: res.data.data.pan || '',
    //                     type_of_deductor: res.data.data.type_of_deductor || deductorType,
    //                     is_revised_return: res.data.data.is_revised_return || false,
    //                     last_deductor_type: res.data.data.last_deductor_type || '',
    //                     update_deductor_details: res.data.data.update_deductor_details || '',
    //                     receipt_number_original: res.data.data.receipt_number_original || '',
    //                     receipt_number_previous: res.data.data.receipt_number_previous || '',
    //                 }));

    //                 setTaxDeductionFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     name: res.data.data.name || '',
    //                     ministry_department_name: res.data.data.ministry_department_name || '',
    //                     ministry_department_name_other: res.data.data.ministry_department_name_other || '',
    //                     branch_division: res.data.data.branch_division || '',
    //                     state_name: res.data.data.state_name || '',
    //                     ddo_code: res.data.data.ddo_code || '',
    //                     pao_code: res.data.data.pao_code || '',
    //                     ddo_registration_number: res.data.data.ddo_registration_number || '',
    //                     pao_registration_number: res.data.data.pao_registration_number || '',
    //                     flat_no: res.data.data.flat_no || '',
    //                     premises_name: res.data.data.premises_name || '',
    //                     road_or_street: res.data.data.road_or_street || '',
    //                     area_or_location: res.data.data.area_or_location || '',
    //                     town_or_city: res.data.data.town_or_city || '',
    //                     pin_code: res.data.data.pin_code || '',
    //                     state: res.data.data.state || '',
    //                     telephone_no: res.data.data.telephone_no || '',
    //                     telephone_alternative: res.data.data.telephone_alternative || '',
    //                     email: res.data.data.email || '',
    //                     email_alternative: res.data.data.email_alternative || '',
    //                     gstn: res.data.data.gstn || '',
    //                     has_address_changed: res.data.data.has_address_changed || false,
    //                     ao_ain: res.data.data.ao_ain || ''
    //                 }));

    //                 setPersonFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     responsible_name: res.data.data.responsible_name || '',
    //                     responsible_pan: res.data.data.responsible_pan || '',
    //                     responsible_designation: res.data.data.responsible_designation || '',
    //                     responsible_flat_no: res.data.data.responsible_flat_no || '',
    //                     responsible_premises_name: res.data.data.responsible_premises_name || '',
    //                     responsible_road_or_street: res.data.data.responsible_road_or_street || '',
    //                     responsible_area_or_location: res.data.data.responsible_area_or_location || '',
    //                     responsible_town_or_city: res.data.data.responsible_town_or_city || '',
    //                     responsible_pin_code: res.data.data.responsible_pin_code || '',
    //                     responsible_state: res.data.data.responsible_state || '',
    //                     responsible_telephone_no: res.data.data.responsible_telephone_no || '',
    //                     responsible_telephone_alternative: res.data.data.responsible_telephone_alternative || '',
    //                     responsible_mobile_no: res.data.data.responsible_mobile_no || '',
    //                     responsible_email: res.data.data.responsible_email || '',
    //                     responsible_email_alternative: res.data.data.responsible_email_alternative || '',
    //                     responsible_address_same: res.data.data.responsible_address_same || true,
    //                     responsible_address_changed: res.data.data.responsible_address_changed || false,
    //                     responsible_receipt_number: res.data.data.responsible_receipt_number || false,
    //                     filed_earlier_period: res.data.data.filed_earlier_period || false,
    //                 }));
    //             } else {
    //                 console.log("Comes here for no data")
    //                 updateTaxDeductorData(taxDeductorData);
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("Error fetching business entity details:", err);
    //         })
    // }

    const updateTaxDeductorData = (deductorData) => {
        let deductorType = ''
        console.log("JSON ==>" + JSON.stringify(deductorData));
        if (deductorData.particulars_of_statement.pan) {
            const fourthChar2 = deductorData.particulars_of_statement.pan.charAt(3);
            if (fourthChar2 === 'C') {
                deductorType = "Company";
            } else if (fourthChar2 === 'B') {
                deductorType = "Body of Individuals";
            } else if (fourthChar2 === 'F') {
                deductorType = "Firm";
            } else if (fourthChar2 === 'P' || fourthChar2 === 'H') {
                deductorType = "Individual/HUF";
            }
        }
        // Update formData with tan and pan from response
        setEmployerDetailFormData(prevFormData => ({
            ...prevFormData,
            quarter: localStorage.getItem('quarter_26Q'),
            tan: deductorData.particulars_of_statement.tan || '',
            financial_year: localStorage.getItem('financial_year_26Q'),
            assessment_year: calculateAssessmentYearFull(localStorage.getItem('financial_year_26Q')),
            pan: deductorData.particulars_of_statement.pan || '',
            type_of_deductor: deductorData.particulars_of_statement.type_of_deductor || deductorType,
        }));

        setTaxDeductionFormData(prevFormData => ({
            ...prevFormData,
            name: deductorData.particulars_of_deductor.name || '',
            email: deductorData.particulars_of_deductor.email || '',
        }));

        setPersonFormData(prevFormData => ({
            ...prevFormData,
            responsible_name: deductorData.particulars_person_responsible_for_deduction.name || '',
            responsible_pan: deductorData.particulars_person_responsible_for_deduction.pan || '',
            responsible_flat_no: deductorData.particulars_person_responsible_for_deduction.flat_no || '',
            responsible_premises_name: deductorData.particulars_person_responsible_for_deduction.premises_name || '',
            responsible_road_or_street: deductorData.particulars_person_responsible_for_deduction.road_or_street || '',
            responsible_area_or_location: deductorData.particulars_person_responsible_for_deduction.area_or_location || '',
            responsible_town_or_city: deductorData.particulars_person_responsible_for_deduction.town_or_city || '',
            responsible_pin_code: deductorData.particulars_person_responsible_for_deduction.pin_code || '',
            responsible_state: (deductorData.particulars_person_responsible_for_deduction.state),
            responsible_telephone_no: deductorData.particulars_person_responsible_for_deduction.telephone_primary || '',
            responsible_telephone_alternative: deductorData.particulars_person_responsible_for_deduction.telephone_alternative || '',
            responsible_mobile_no: deductorData.particulars_person_responsible_for_deduction.mobile_no || '',
            responsible_email: deductorData.particulars_person_responsible_for_deduction.email || '',
            responsible_email_alternative: deductorData.particulars_person_responsible_for_deduction.email_alternative || '',
        }));
    }

    const getBusinessEntityDetails = () => {
        return axios.get(`/get_form26q_initial_form_data/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                if (res?.data?.status) {
                    if (res?.data?.message) {
                        // toast.warning(res?.data?.message || '', {
                        //     autoClose: 3000,
                        //     progress: 0,
                        // });
                    }
                    setTaxDeductorData(res.data.data);
                    updateTaxDeductorData(res.data.data);
                    return res.data.data;
                }
            })
            .catch((err) => {
                console.error("Error fetching business entity details:", err);
            })
    }

    const handleChange = (e) => {
        if (e) {
            const { name, value } = e.target;
            if (name === 'pan') {
                const fourthChar2 = value.charAt(3);
                console.log("Pan Char at 4 ==>" + fourthChar2 + " and visibility of State ==>" + stateVisible);
                if (fourthChar2 === 'C' || fourthChar2 === 'B' || fourthChar2 === 'F' || fourthChar2 === 'P') {
                    setStateVisible("edit");
                } else {
                    setStateVisible("view");
                }
                console.log("Pan Char at 4 ==>" + fourthChar2 + " and visibility of State ==>" + stateVisible);
            }

            if (name === 'financial_year') {
                const assessmentYear = calculateAssessmentYearFull(value);
                setEmployerDetailFormData({
                    ...employerDetailFormData,
                    [name]: value,
                    assessment_year: assessmentYear
                });
            } else if (name === "is_revised_return") {
                const val = value === 1 ? true : false;
                setEmployerDetailFormData({
                    ...employerDetailFormData,
                    is_revised_return: val
                });
            } else {
                setEmployerDetailFormData({ ...employerDetailFormData, [name]: value });
            }
            // Clear error when user starts typing
            if (errors[name]) {
                setErrors(prev => ({
                    ...prev,
                    [name]: ''
                }));
            }
        }
    }

    const calculateAssessmentYearFull = (financialYear) => {
        const startYear = parseInt(financialYear.split('-')[0]);
        const assessmentStartYear = startYear + 1;
        const assessmentEndYear = startYear + 2;

        return `${assessmentStartYear}-${assessmentEndYear}`;
    }

    const handleEmployerChange = (e) => {
        if (e) {
            const { name, value } = e.target;

            if (name === "has_address_changed") {
                const val = value === 1 ? true : false;
                setTaxDeductionFormData({
                    ...employerDetailFormData,
                    has_address_changed: val,
                });

            } else {
                setTaxDeductionFormData({ ...taxDeductionFormData, [name]: value });
            }

            // Clear error when user starts typing
            if (errors[name]) {
                setErrors(prev => ({
                    ...prev,
                    [name]: ''
                }));
            }
        }
    }

    const handleDeductorChange = (e) => {
        if (e) {
            const { name, value } = e.target;

            if (name === "responsible_address_same") {
                const val = value === 1 ? true : false;

                if (value === 2) { // When "No" is selected
                    const responsiblePersonData = taxDeductorData.particulars_person_responsible_for_deduction;
                    const isResponsiblePersonEmpty = !responsiblePersonData || Object.keys(responsiblePersonData).length === 0;

                    if (isResponsiblePersonEmpty) {
                        toast.warning('Please add the deduction person data in business entity details', {
                            autoClose: 3000,
                            progress: 0,
                        });
                    }
                }

                setPersonFormData({
                    ...personFormData,
                    //has_address_changed: val,
                    responsible_name: val === true ? taxDeductionFormData.name : taxDeductorData.particulars_person_responsible_for_deduction.name,
                    // responsible_pan: val === true ? employerDetailFormData.pan : taxDeductorData.particulars_person_responsible_for_deduction.pan,
                    responsible_pan: val === true ? '' : taxDeductorData.particulars_person_responsible_for_deduction.pan,
                    responsible_flat_no: val === true ? taxDeductionFormData.flat_no : taxDeductorData.particulars_person_responsible_for_deduction.flat_no,
                    responsible_premises_name: val === true ? taxDeductionFormData.premises_name : taxDeductorData.particulars_person_responsible_for_deduction.premises_name,
                    responsible_road_or_street: val === true ? taxDeductionFormData.road_or_street : taxDeductorData.particulars_person_responsible_for_deduction.road_or_street,
                    responsible_area_or_location: val === true ? taxDeductionFormData.area_or_location : taxDeductorData.particulars_person_responsible_for_deduction.area_or_location,
                    responsible_town_or_city: val === true ? taxDeductionFormData.town_or_city : taxDeductorData.particulars_person_responsible_for_deduction.town_or_city,
                    responsible_pin_code: val === true ? taxDeductionFormData.pin_code : taxDeductorData.particulars_person_responsible_for_deduction.pin_code,
                    responsible_state: val === true ? (taxDeductionFormData.state) : (taxDeductorData.particulars_person_responsible_for_deduction.state),
                    responsible_telephone_no: val === true ? taxDeductionFormData.telephone_no : taxDeductorData.particulars_person_responsible_for_deduction.telephone_primary,
                    responsible_telephone_alternative: val === true ? taxDeductionFormData.telephone_alternative : taxDeductorData.particulars_person_responsible_for_deduction.telephone_alternative,
                    responsible_email: val === true ? taxDeductionFormData.email : taxDeductorData.particulars_person_responsible_for_deduction.email,
                    responsible_email_alternative: val === true ? taxDeductionFormData.email_alternative : taxDeductorData.particulars_person_responsible_for_deduction.email_alternative,
                    responsible_mobile_no: val === true ? '' : taxDeductorData.particulars_person_responsible_for_deduction.mobile_no,
                    responsible_designation: val === true ? '' : taxDeductorData.particulars_person_responsible_for_deduction.designation,
                    [name]: val
                });
                if (val === true && errors.responsible_pan) {
                    setErrors(prev => {
                        const newErrors = { ...prev };
                        delete newErrors.responsible_pan;
                        return newErrors;
                    });
                }
            } else if (name === "responsible_address_changed" || name === "responsible_receipt_number" || name === "filed_earlier_period") {
                const val = value === 1 ? true : false;
                setPersonFormData({
                    ...personFormData,
                    [name]: val
                });
            } else {
                setPersonFormData({ ...personFormData, [name]: value });

                // Add validation for responsible_pan to check if it matches employerDetailFormData.pan
                if (name === "responsible_pan" && value && employerDetailFormData.pan) {
                    if (value.toUpperCase() === employerDetailFormData.pan.toUpperCase()) {
                        setErrors(prev => ({
                            ...prev,
                            responsible_pan: 'Responsible person PAN cannot be same as Deductor PAN'
                        }));
                    } else {
                        // Clear the error if PANs are different
                        setErrors(prev => {
                            const newErrors = { ...prev };
                            delete newErrors.responsible_pan;
                            return newErrors;
                        });
                    }
                }
            }

            // Clear error when user starts typing
            if (errors[name] && name !== "responsible_pan") {
                setErrors(prev => ({
                    ...prev,
                    [name]: ''
                }));
            }
        }
    }

    const handleFormDetailsBack = () => {
        console.log("Active Step ==>" + activeStep);
        if (activeStep == 0) {
            history.goBack()
            return
        }
        setActiveStep(Math.max(0, activeStep - 1));
    };

    const handleFormDetailSubmit = () => {
        setCompletedSteps(prev => new Set(prev).add(activeStep));
        if (activeStep < formSteps.length - 1) {
            setActiveStep(activeStep + 1);
        }

        if (personFormData.responsible_address_same === true) {
            console.log("taxDeductionFormData.state_name =======" + taxDeductionFormData.state);
            setPersonFormData({
                ...personFormData,
                //has_address_changed: val,
                responsible_name: taxDeductionFormData.name,
                responsible_pan: '',
                // responsible_pan: employerDetailFormData.pan,
                responsible_flat_no: taxDeductionFormData.flat_no,
                responsible_premises_name: taxDeductionFormData.premises_name,
                responsible_road_or_street: taxDeductionFormData.road_or_street,
                responsible_area_or_location: taxDeductionFormData.area_or_location,
                responsible_town_or_city: taxDeductionFormData.town_or_city,
                responsible_pin_code: taxDeductionFormData.pin_code,
                responsible_state: (taxDeductionFormData.state),
                responsible_telephone_no: taxDeductionFormData.telephone_no,
                responsible_telephone_alternative: taxDeductionFormData.telephone_alternative,
                responsible_email: taxDeductionFormData.email,
                responsible_email_alternative: taxDeductionFormData.email_alternative,
                responsible_address_same: true,
                responsible_mobile_no: ''
            });
        } else {
            // ✅ ADDED: When "No" is selected, fetch PAN from taxDeductorData
            setPersonFormData({
                ...personFormData,
                responsible_pan: taxDeductorData.particulars_person_responsible_for_deduction?.pan || '',
            });
        }
    }

    const fileUploader = (event) => {
        if (event.target.files[0]) {
            const file_data = event.target.files[0];
            let fileName = file_data.name;
            setFileName(fileName);
            const reader = new FileReader();
            reader.readAsDataURL(file_data);
            reader.onload = function () {
                let file_value = reader.result;
                setCSIfile(file_value);
            };
            document.getElementById("file_value").value = null;
        }
    };

    const handleSubmit = () => {
        if (!fileName || fileName.trim() === "") {
            toast.error("Upload the CSI File", {
                autoClose: 5000,
                progress: 0,
            });
        } else {
            const payload = {
                ...employerDetailFormData,
                ...taxDeductionFormData,
                ...personFormData,
                business_entity_id: localStorage.getItem('business_entity_id'),
                csi_file_data: CSIfile,
                csi_file_name: fileName
            }
            console.log("Payload ==>" + JSON.stringify(payload));
            let url = "";
            let msg = "";
            if (isEdit === 0) {
                url = "/create_form_26q";
                msg = "Data saved successfully!";
            } else {
                url = "/update_form_26q";
                msg = "Data updated successfully!";
            }
            axios.post(url, payload)
                .then((res) => {
                    if (res?.data.status === false) {
                        toast.error(res?.data?.message || msg, {
                            autoClose: 3000,
                            progress: 0,
                        });
                    } else {
                        toast.success(res?.data?.message || msg, {
                            autoClose: 3000,
                            progress: 0,
                        });
                        getChallanDetails();
                        getAnnexureDetails();
                        getForm26QData();
                        setActiveFormStep((prevActiveFormStep) => prevActiveFormStep + 1);
                        setFileName("");
                    }
                })
                .catch((err) => {
                    toast.error(err?.response?.data?.message || "An error occurred while saving data.", {
                        autoClose: 3000,
                        progress: 0,
                    });
                });
        }
    };


    const handleFile26Q = () => {
        history.push('/26QFiling')
        const payLoadData = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            quarter: localStorage.getItem('quarter_26Q'),
            tan: employerDetailFormData.tan
        }
        axios.post('/tds_26Q_filing', payLoadData)
            .then((res) => {

            }).catch((err) => {

            })
    }

    const handleStepClick = (stepIndex) => {
        if (completedSteps.has(stepIndex) || stepIndex <= activeStep) {
            setActiveStep(stepIndex);
        }
        return;
    };

    const typeOfDeductorOptions = [
        { value: 'Artificial Juridical Person (AOP)', label: 'Artificial Juridical Person (AOP)' },
        { value: 'Association of Person (Trust)', label: 'Association of Person (Trust)' },
        { value: 'Autonomous Body (Central Govt.)', label: 'Autonomous Body (Central Govt.)' },
        { value: 'Autonomous Body (State Govt.)', label: 'Autonomous Body (State Govt.)' },
        { value: 'Body of Individuals', label: 'Body of Individuals' },
        { value: 'Branch / Division of Company', label: 'Branch / Division of Company' },
        { value: 'Central Government', label: 'Central Government' },
        { value: 'Company', label: 'Company' },
        { value: 'Firm', label: 'Firm' },
        { value: 'Individual/HUF', label: 'Individual/HUF' },
        { value: 'Local Authority (Central Govt.)', label: 'Local Authority (Central Govt.)' },
        { value: 'Local Authority (State Govt.)', label: 'Local Authority (State Govt.)' },
        { value: 'State Government', label: 'State Government' },
        { value: 'Statutory Body (Central Govt.)', label: 'Statutory Body (Central Govt.)' },
        { value: 'Statutory Body (State Govt.)', label: 'Statutory Body (State Govt.)' }
    ];

    const getFinancialYearOptions = () => {
        const today = new Date();
        const currentMonth = today.getMonth(); // 0-indexed (0 for Jan, 6 for July)
        let currentYear = today.getFullYear();

        // Determine the current financial year
        // If the current month is before April (0, 1, 2), the financial year started in the previous calendar year.
        // Otherwise (April to December), the financial year started in the current calendar year.
        if (currentMonth < 3) { // Months 0, 1, 2 (Jan, Feb, Mar)
            currentYear = currentYear - 1;
        }

        const financialYearOptions = [];

        // Add -5 years
        for (let i = 5; i > 0; i--) {
            const startYear = currentYear - i;
            const endYear = startYear + 1;
            const value = `${startYear}-${String(endYear).slice(2)}`;
            financialYearOptions.push({ value: value, label: value });
        }

        // Add current financial year
        const currentFYStartYear = currentYear;
        const currentFYEndYear = currentYear + 1;
        const currentFYValue = `${currentFYStartYear}-${String(currentFYEndYear).slice(2)}`;
        financialYearOptions.push({ value: currentFYValue, label: currentFYValue });

        // Add +5 years
        for (let i = 1; i <= 5; i++) {
            const startYear = currentYear + i;
            const endYear = startYear + 1;
            const value = `${startYear}-${String(endYear).slice(2)}`;
            financialYearOptions.push({ value: value, label: value });
        }
        console.log("Financial Year ==>" + JSON.stringify(financialYearOptions));
        return financialYearOptions;
    };



    const FormStep0 = () => {
        return (
            <ValidatorForm
                useRef="formStep0"
                onSubmit={handleFormDetailSubmit}
                onError={(errors) => console.log(errors)}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Financial Year
                            <span style={{ color: 'red' }}>*</span>:
                        </label>

                        <SelectInput
                            choice_id="value"
                            validator={['required']}
                            errorMsg={['Financial Year is required']}
                            choice_name="label"
                            name="financial_year"
                            value={employerDetailFormData.financial_year}
                            textOnchangeFunction={handleChange}
                            choices={financialYearOptions}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Tax Deduction Account Number
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            id="outlined-basic"
                            fullWidth={true}
                            size="small"
                            variant="outlined"
                            name="tan"
                            value={employerDetailFormData.tan}
                            onChange={handleChange}
                            inputProps={{ maxLength: 10 }}
                            requiredField="*"
                            validators={[
                                "required",
                                "matchRegexp:^[A-Z]{4}[0-9]{5}[A-Z]{1}$",
                            ]}
                            errorMessages={[
                                "TAN is required",
                                "Must be a TAN number",
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Last Tax Deduction Account Number:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="last_tan"
                            value={employerDetailFormData.last_tan}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Assessment Year
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="assessment_year"
                            value={employerDetailFormData.assessment_year}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                            validators={["required"]}
                            errorMessages={["Assessment Year is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Permanent Account Number (PAN)
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pan"
                            value={employerDetailFormData.pan?.toUpperCase() ?? ""}
                            onChange={handleChange}
                            inputProps={{ maxLength: 10 }}
                            validators={[
                                "required",
                                "matchRegexp:^[A-Z]{5}[0-9]{4}[A-Z]{1}$",
                            ]}
                            errorMessages={[
                                "PAN is required",
                                "Must be a PAN number",
                            ]}
                        />{errors["pan"] && (
                            <p style={{
                                color: '#ef4444',
                                fontSize: '12px',
                                marginTop: '4px',
                                marginBottom: '0'
                            }}>
                                {errors["pan"]}
                            </p>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Type of Deductor
                            <span style={{ color: 'red' }}>*</span>:
                        </label>

                        <SelectInput
                            choice_id="value"
                            choice_name="label"
                            name="type_of_deductor"
                            value={employerDetailFormData.type_of_deductor}
                            textOnchangeFunction={handleChange}
                            choices={typeOfDeductorOptions}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />{errors["type_of_deductor"] && (
                            <p style={{
                                color: '#ef4444',
                                fontSize: '12px',
                                marginTop: '4px',
                                marginBottom: '0'
                            }}>
                                {"Type of Deductor is required"}
                            </p>
                        )}
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Is this a Revised Return?:
                        </label>
                        <SelectInput
                            choice_id="id"
                            choice_name="reverse_charge"
                            name="is_revised_return"
                            value={employerDetailFormData.is_revised_return === true ? 1 : 2}
                            textOnchangeFunction={handleChange}
                            choices={[
                                {
                                    "id": 1,
                                    "reverse_charge": "Yes",
                                },
                                {
                                    "id": 2,
                                    "reverse_charge": "No",
                                }
                            ]}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Last Deductor type:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="last_deductor_type"
                            value={employerDetailFormData.last_deductor_type}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Update Deductor Details:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="update_deductor_details"
                            value={employerDetailFormData.update_deductor_details}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Receipt Number of Original Return:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="receipt_number_original"
                            value={employerDetailFormData.receipt_number_original}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Receipt Number of Previous Return:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="receipt_number_previous"
                            value={employerDetailFormData.receipt_number_previous}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>
                {/* Step Actions */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: '1.5%',
                    // paddingTop: '2%',
                    // borderTop: '1px solid #e5e7eb'
                }}>
                    <button
                        onClick={handleFormDetailsBack}
                        // disabled={activeStep === 0}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#ffffff',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '12px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >
                        Back
                    </button>
                    <button type="submit"
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#2563eb',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
                    >
                        Continue
                    </button>
                </div>
            </ValidatorForm>

        )
    }

    const FormStep1 = () => {
        return (
            <ValidatorForm
                useRef="formStep1"
                onError={(errors) => console.log(errors)}
                onSubmit={handleFormDetailSubmit}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Employer Name
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="name"
                            value={taxDeductionFormData.name}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />{errors["name"] && (
                            <p style={{
                                color: '#ef4444',
                                fontSize: '12px',
                                marginTop: '4px',
                                marginBottom: '0'
                            }}>
                                {"Employer Name is required"}
                            </p>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Ministry / Dept. Name:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ministry_department_name"
                            value={taxDeductionFormData.ministry_department_name}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Branch / Division:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="branch_division"
                            value={taxDeductionFormData.branch_division}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Ministry / Dept. Name (Others):
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ministry_department_name_other"
                            value={taxDeductionFormData.ministry_department_name_other}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            State Name:
                        </label>
                        <SelectInput
                            choice_id="id"
                            choice_name="value"
                            name="state_name"
                            value={taxDeductionFormData.state_name}
                            textOnchangeFunction={handleEmployerChange}
                            choices={State}
                            // validators={["required"]}
                            // errorMessages={["This field is required"]}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />
                        {errors["name"] && (
                            <p style={{
                                color: '#ef4444',
                                fontSize: '12px',
                                marginTop: '4px',
                                marginBottom: '0'
                            }}>
                                {"State is required"}
                            </p>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            DDO Code:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ddo_code"
                            value={taxDeductionFormData.ddo_code}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            PAO Code:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pao_code"
                            value={taxDeductionFormData.pao_code}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            DDO Registration Number:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ddo_registration_number"
                            value={taxDeductionFormData.ddo_registration_number}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            PAO Registration Number:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pao_registration_number"
                            value={taxDeductionFormData.pao_registration_number}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Flat No.
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="flat_no"
                            value={taxDeductionFormData.flat_no}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                            validators={[
                                "required",
                            ]}
                            errorMessages={["Flat No is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Name of Premises / Building:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="premises_name"
                            value={taxDeductionFormData.premises_name}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Road / Street / Lane:
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="road_or_street"
                            value={taxDeductionFormData.road_or_street}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Area / Location:
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="area_or_location"
                            value={taxDeductionFormData.area_or_location}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Town / City / District:
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="town_or_city"
                            value={taxDeductionFormData.town_or_city}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            PIN Code
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pin_code"
                            value={taxDeductionFormData.pin_code}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 6, }}
                            onKeyPress={(event) => {
                                if (!/^[0-9]$/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            validators={[
                                "required",
                                'matchRegexp:^[0-9]{6}$']}
                            errorMessages={["Pin Code is required", 'Must be a 6-digit pincode']}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            State
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <SelectInput
                            choice_id="value"
                            choice_name="value"
                            name="state"
                            value={taxDeductionFormData.state}
                            textOnchangeFunction={handleEmployerChange}
                            choices={State}
                            validators={[
                                "required"]}
                            errorMessages={["State is required"]}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Telephone No:
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="telephone_no"
                            value={taxDeductionFormData.telephone_no}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 10 }}
                            validators={["required", "matchRegexp:^[0-9]{10}$"]}
                            errorMessages={["This field is required", "Invalid mobile number"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Telephone No (Alternative):
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="telephone_alternative"
                            value={taxDeductionFormData.telephone_alternative}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 10 }}
                            validators={["matchRegexp:^[0-9]{10}$"]}
                            errorMessages={["Invalid mobile number"]}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            E-mail:
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="email"
                            value={taxDeductionFormData.email}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                            validators={["required", "isEmail"]}
                            errorMessages={["This field is required", "Email is not Valid"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            E-mail (Alternative):
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="email_alternative"
                            value={taxDeductionFormData.email_alternative}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                            validators={["isEmail"]}
                            errorMessages={["Email is not Valid"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Account Office Identification Number (AIN):
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ao_ain"
                            value={taxDeductionFormData.ao_ain}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Has Address Changed since Last Return?:
                        </label>
                        <SelectInput
                            choice_id="id"
                            choice_name="reverse_charge"
                            name="has_address_changed"
                            value={taxDeductionFormData.has_address_changed === true ? 1 : 2}
                            textOnchangeFunction={handleEmployerChange}
                            choices={[
                                {
                                    "id": 1,
                                    "reverse_charge": "Yes",
                                },
                                {
                                    "id": 2,
                                    "reverse_charge": "No",
                                }
                            ]}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Goods and Service Tax Number (GSTN):
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="gstn"
                            value={taxDeductionFormData.gstn || localStorage.getItem('gst')}
                            validator={[
                                "required", "matchRegexp:^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[A-Za-z][0-9A-Za-z]{1}$"
                            ]}
                            errorMsg={["GSTIN is required", "Must be a GSTIN number"]}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />

                    </Grid>
                </Grid>
                {/* Step Actions */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: '1.5%',
                    // paddingTop: '2%',
                    // borderTop: '1px solid #e5e7eb'
                }}>
                    <button
                        onClick={handleFormDetailsBack}
                        // disabled={activeStep === 0}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#ffffff',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '12px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >
                        Back
                    </button>
                    <button type="submit"
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#2563eb',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
                    >
                        Continue
                    </button>
                </div>
            </ValidatorForm>
        )
    }

    const FormStep2 = () => {
        return (
            <>
                <ValidatorForm
                    useRef="formStep2"
                    onError={(errors) => console.log(errors)}
                    onSubmit={handleSubmit}
                >
                    {/* All your existing form content here */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4} mt={0.7}>
                            <label>
                                Same as previous data:
                            </label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="responsible_address_same"
                                value={personFormData.responsible_address_same === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    {
                                        "id": 1,
                                        "reverse_charge": "Yes",
                                    },
                                    {
                                        "id": 2,
                                        "reverse_charge": "No",
                                    }
                                ]}
                                sx={{
                                    height: '40px', // Ensure consistent height
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px', // Consistent padding
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Name
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_name"
                                value={personFormData.responsible_name}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["required"]}
                                errorMessages={["Name is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Permanent Account Number (PAN)<span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_pan"
                                value={personFormData.responsible_pan?.toUpperCase() ?? ""}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 10 }}
                                validators={[
                                    "required",
                                    "matchRegexp:^[A-Z]{5}[0-9]{4}[A-Z]{1}$",
                                    "isPANDifferent"
                                ]}
                                errorMessages={[
                                    "PAN is required",
                                    "Must be a PAN number",
                                    "Responsible person PAN cannot be same as Deductor PAN"
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Designation<span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_designation"
                                value={personFormData.responsible_designation}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["required"]}
                                errorMessages={["Designation is required"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Flat No.
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_flat_no"
                                value={personFormData.responsible_flat_no}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["required"]}
                                errorMessages={["Flat No is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Name of Premises / Building:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_premises_name"
                                value={personFormData.responsible_premises_name}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Road / Street / Lane
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_road_or_street"
                                value={personFormData.responsible_road_or_street}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Area / Location
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_area_or_location"
                                value={personFormData.responsible_area_or_location}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Town / City / District
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_town_or_city"
                                value={personFormData.responsible_town_or_city}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                PIN Code
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_pin_code"
                                value={personFormData.responsible_pin_code}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 6, }}
                                onKeyPress={(event) => {
                                    if (!/^[0-9]$/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                                validators={["required", "matchRegexp:^[0-9]{6}$"]}
                                errorMessages={["Pin Code is required", "Must be a 6-digit pincode"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4} mt={0.7}>
                            <label style={{ display: 'block', marginBottom: '3px' }}>
                                State
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <SelectInput
                                choice_id="value"
                                choice_name="value"
                                name="responsible_state"
                                value={personFormData.responsible_state}
                                textOnchangeFunction={handleDeductorChange}
                                choices={State}
                                validators={["required"]}
                                errorMessages={["State is required"]}
                                sx={{
                                    height: '40px', // Ensure consistent height
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px', // Consistent padding
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Telephone No
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_telephone_no"
                                value={personFormData.responsible_telephone_no}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["required", "matchRegexp:^[0-9]{10}$"]}
                                errorMessages={["This field is required", "Invalid mobile number"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Telephone No (Alternative):
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_telephone_alternative"
                                value={personFormData.responsible_telephone_alternative}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["matchRegexp:^[0-9]{10}$"]}
                                errorMessages={["Invalid mobile number"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>
                                E-mail
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_email"
                                value={personFormData.responsible_email}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["required", "isEmail"]}
                                errorMessages={["This field is required", "Email is not Valid"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                E-mail (Alternative):
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_email_alternative"
                                value={personFormData.responsible_email_alternative}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["isEmail"]}
                                errorMessages={["Email is not Valid"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Mobile No.
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_mobile_no"
                                value={personFormData.responsible_mobile_no}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["matchRegexp:^[0-9]{10}$"]}
                                errorMessages={["Invalid mobile number"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4} mt={1}>
                            <label style={{ display: 'block', marginBottom: '3px' }}>
                                Has Address Changed since Last Return?:
                            </label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="responsible_address_changed"
                                value={personFormData.responsible_address_changed === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    {
                                        "id": 1,
                                        "reverse_charge": "Yes",
                                    },
                                    {
                                        "id": 2,
                                        "reverse_charge": "No",
                                    }
                                ]}
                                sx={{
                                    height: '40px', // Ensure consistent height
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px', // Consistent padding
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Receipt No. of earlier Statement filed for Form:
                            </label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="responsible_receipt_number"
                                value={personFormData.responsible_receipt_number === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    {
                                        "id": 1,
                                        "reverse_charge": "Yes",
                                    },
                                    {
                                        "id": 2,
                                        "reverse_charge": "No",
                                    }
                                ]}
                                sx={{
                                    height: '40px', // Ensure consistent height
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px', // Consistent padding
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Has regular statement for Form 26Q filed for earlier period:
                            </label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="filed_earlier_period"
                                value={personFormData.filed_earlier_period === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    {
                                        "id": 1,
                                        "reverse_charge": "Yes",
                                    },
                                    {
                                        "id": 2,
                                        "reverse_charge": "No",
                                    }
                                ]}
                                sx={{
                                    height: '40px', // Ensure consistent height
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px', // Consistent padding
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        {personFormData.filed_earlier_period === true && (
                            <Grid item xs={12} sm={4}>
                                <label>
                                    Previous Statement Number<span style={{ color: "red" }}>*</span>:
                                </label>
                                <TextValidator
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="previous_statement_number"
                                    value={personFormData.previous_statement_number || ''}
                                    onChange={handleDeductorChange}
                                    inputProps={{ maxLength: 15 }}
                                    onKeyPress={(e) => {
                                        if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    validators={["required", "matchRegexp:^[0-9]{1,15}$"]}
                                    errorMessages={[
                                        "Previous Statement Number is required",
                                        "Only numbers allowed (max 15 digits)"
                                    ]}
                                />
                            </Grid>
                        )}
                    </Grid>

                    <BoxWrapper boxTitle="CSI File Upload" >
                        <Grid container spacing={3}>
                            <Grid item xs={3} md={1}>
                                <label
                                    className="button-primary"
                                    style={{
                                        width: "100%",
                                        textAlign: "center",
                                        cursor: "pointer",
                                    }}
                                >
                                    Browse
                                    <input
                                        id="file_value"
                                        name="CSIfile"
                                        accept=".csi"
                                        type="file"
                                        hidden
                                        onChange={fileUploader}
                                    />
                                </label>
                            </Grid>
                            <Grid item xs={4} md={4}>
                                <TextValidator
                                    validators={["required"]}
                                    errorMessages={["This field is required"]}
                                    placeholder="Choose file"
                                    value={fileName}
                                    name="csi_file_uploader"
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                        </Grid>
                    </BoxWrapper>

                    {/* Step Actions - Both buttons inside ValidatorForm on same line */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: '1.5%',
                        // paddingTop: '2%',
                        // borderTop: '1px solid #e5e7eb'
                    }}>
                        <button
                            type="button"
                            onClick={handleFormDetailsBack}
                            style={{
                                padding: '12px 24px',
                                backgroundColor: '#ffffff',
                                color: '#374151',
                                border: '1px solid #d1d5db',
                                borderRadius: '12px',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            Back
                        </button>
                        <button type="submit"
                            style={{
                                padding: '12px 24px',
                                backgroundColor: '#1d4ed8',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#30b614'}
                        >
                            Submit
                        </button>
                    </div>
                </ValidatorForm>
            </>
        )
    }

    const financialYearOptions = getFinancialYearOptions();

    const formSteps = [
        {
            id: 0,
            title: 'Particulars of Deductor (Employer)',
            description: 'Basic details of the deductor (Employer)',
            content: FormStep0 // ✅ Pass function reference
        },
        {
            id: 1,
            title: 'Deduction of Tax',
            description: 'Particulars of the Person Responsible for Deduction of Tax',
            content: FormStep1 // ✅ Pass function reference
        },
        {
            id: 2,
            title: 'Person Responsible',
            description: 'Details of person responsible for deduction of tax',
            content: FormStep2 // ✅ Pass function reference
        }
    ];


    const StepIndicator = ({ step, isActive, isCompleted, onClick }) => (
        <div
            onClick={() => onClick(step.id)}
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: '16px',
                borderRadius: '12px',
                backgroundColor: isActive ? '#eff6ff' : isCompleted ? '#f0f9ff' : '#f8fafc',
                border: isActive ? '2px solid #2563eb' : '1px solid #e5e7eb',
                cursor: (isCompleted || step.id <= activeStep) ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s ease-in-out',
                opacity: (isCompleted || step.id <= activeStep) ? 1 : 0.6,
                marginBottom: '12px'
            }}
        >
            <div
                style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: isCompleted ? '#10b981' : isActive ? '#2563eb' : '#e5e7eb',
                    color: isCompleted || isActive ? '#ffffff' : '#6b7280',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: '600',
                    marginRight: '12px',
                    flexShrink: 0
                }}
            >
                {isCompleted ? <CheckIcon size={16} /> : step.id + 1}
            </div>
            <div style={{ flex: 1 }}>
                <div style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: isActive ? '#2563eb' : '#374151',
                    marginBottom: '4px'
                }}>
                    {step.title}
                </div>
                <div style={{
                    fontSize: '14px',
                    color: '#6b7280'
                }}>
                    {step.description}
                </div>
            </div>
            {isActive && <ChevronRightIcon size={20} color="#2563eb" />}
        </div>
    );

    const challanColumns = [
        { field: 'sr_no', headerName: 'Sr No', flex: 1, minWidth: 80 },
        { field: 'challan_no', headerName: 'Challan No', flex: 1, minWidth: 120 },
        { field: 'challan_date', headerName: 'Challan Date', flex: 1, minWidth: 120 },
        { field: 'bsr_code', headerName: 'BSR Code', flex: 1, minWidth: 120 },
        { field: 'section', headerName: 'Section', flex: 1, minWidth: 100 },
        {
            field: 'tds',
            headerName: 'TDS',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'surcharge',
            headerName: 'Surcharge',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'cess',
            headerName: 'CESS',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'interest',
            headerName: 'Interest',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'penalty',
            headerName: 'Penalty',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'fee',
            headerName: 'Fees',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'total',
            headerName: 'Total',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
    ];


    const annexureColumns = [
        { field: 'challan_no', headerName: 'Challan No', flex: 1, minWidth: 120 },
        { field: 'section', headerName: 'Section', flex: 1, minWidth: 100 },
        { field: 'pan', headerName: 'PAN', flex: 1, minWidth: 100 },
        { field: 'name', headerName: 'Name', flex: 1, minWidth: 120 },
        { field: 'date_of_payment', headerName: 'Date of Payment', flex: 1, minWidth: 120 },
        { field: 'date_of_deduction', headerName: 'Date of Deduction', flex: 1, minWidth: 120 },
        {
            field: 'tds_percentage',
            headerName: 'TDS Percentage',
            flex: 1,
            minWidth: 130,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'tds',
            headerName: 'TDS',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'surcharge',
            headerName: 'Surcharge',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'cess',
            headerName: 'CESS',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'tax',
            headerName: 'Tax',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'amount_paid',
            headerName: 'Amount Paid',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
    ];

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const handleDownloadReport = () => {
        const financial_year = localStorage.getItem('financial_year_26Q')
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `26Q Annexure RPU.xlsx`;

        axios
            .post(`/generate_tds_rpu_excel_report`, {
                business_entity_id: localStorage.getItem("business_entity_id"),
                financial_year: financial_year,
                quarter: localStorage.getItem('quarter_26Q')
            })
            .then((res) => {
                downloadBase64File(contentType, res.data.file, filename);
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {

            })
    }


    const formatCurrency = (value) => {
        if (!value || value == null || value === '') return '₹0';
        return `₹${value.toLocaleString('en-IN')}`;
    };

    const FormDetails = () => {
        const renderFormStep = () => {
            switch (activeStep) {
                case 0:
                    return FormStep0();
                case 1:
                    return FormStep1();
                case 2:
                    return FormStep2();
                default:
                    return FormStep0();
            }
        };

        return (
            <div style={{
                backgroundColor: 'rgb(246, 246, 249)',
                padding: '8px'
            }}>
                <div style={{
                    maxWidth: 'auto',
                    margin: '0 auto',
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '360px 1fr',
                    }}>
                        {/* Step Navigation */}
                        <div style={{
                            backgroundColor: '#f8fafc',
                            padding: '24px',
                            borderRight: '1px solid #e5e7eb'
                        }}>
                            <h3 style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#374151',
                                marginBottom: '20px'
                            }}>
                                Form 26Q Details
                            </h3>
                            {formSteps.map((step) => (
                                <StepIndicator
                                    key={step.id}
                                    step={step}
                                    isActive={activeStep === step.id}
                                    isCompleted={completedSteps.has(step.id)}
                                    onClick={handleStepClick}
                                />
                            ))}
                        </div>

                        {/* Step Content */}
                        <div style={{ padding: '2%' }}>
                            <div>
                                {renderFormStep()} {/* Use the switch function */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    // const FormDetails = () => {
    //     return (
    //         <div style={{
    //             backgroundColor: 'rgb(246, 246, 249)',
    //             padding: '8px'
    //         }}>
    //             <div style={{
    //                 maxWidth: 'auto',
    //                 margin: '0 auto',
    //                 backgroundColor: '#ffffff',
    //                 borderRadius: '16px',
    //                 boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
    //                 overflow: 'hidden'
    //             }}>
    //                 {/* Header */}

    //                 <div style={{
    //                     display: 'grid',
    //                     gridTemplateColumns: '360px 1fr',

    //                 }}>
    //                     {/* Step Navigation */}
    //                     <div style={{
    //                         backgroundColor: '#f8fafc',
    //                         padding: '24px',
    //                         borderRight: '1px solid #e5e7eb'
    //                     }}>
    //                         <h3 style={{
    //                             fontSize: '18px',
    //                             fontWeight: '600',
    //                             color: '#374151',
    //                             marginBottom: '20px'
    //                         }}>
    //                             Form 26Q Details
    //                         </h3>
    //                         {formSteps.map((step) => (
    //                             <StepIndicator
    //                                 key={step.id}
    //                                 step={step}
    //                                 isActive={activeStep === step.id}
    //                                 isCompleted={completedSteps.has(step.id)}
    //                                 onClick={handleStepClick}
    //                             />
    //                         ))}
    //                     </div>

    //                     {/* Step Content */}
    //                     <div style={{ padding: '2%' }}>
    //                         <>

    //                             <div>
    //                                 {formSteps[activeStep].content()}
    //                             </div>



    //                         </>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // };

    const ChallanTable = () => (
        <div style={{ marginTop: '20px' }}>
            <DataGridPro
                rows={challanData}
                columns={challanColumns}
                getRowId={(row) => row.sr_no}
                // autoHeight
                pagination
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                isRowSelectable={() => false}
                sx={{
                    height: '55vh',
                    marginTop: 2,
                    '& .MuiDataGrid-columnHeaders': {
                        // backgroundColor: '#1976d2',
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textAlign: 'right',
                        zIndex: 1000,
                    },
                    '& .MuiDataGrid-columnHeader': {
                        position: 'relative',
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold',
                        backgroundColor: '#607d8b',
                    },

                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#fff',
                    },
                    "& .MuiDataGrid-sortIcon": {
                        opacity: 'inherit !important',
                    },

                    "& .MuiDataGrid-iconButtonContainer": {
                        visibility: 'visible',
                    },
                    '& .MuiDataGrid-menuIconButton': {
                        opacity: '1 !important',
                        visibility: 'visible !important',
                        display: 'flex !important',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        '& .MuiDataGrid-columnHeader': {
                            '& .MuiDataGrid-menuIconButton': {
                                display: 'flex !important',
                                visibility: 'visible !important',
                                opacity: '1 !important',
                            },
                        },
                    },
                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .MuiDataGrid-cell': {
                        padding: '8px',
                        textAlign: 'center',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f0f0f0',
                    },
                    '& .MuiCheckbox-root': {
                        color: '#1976d2',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#d3e3fc',
                        cursor: 'pointer'
                    },
                }}
            />
        </div>
    );

    const AnnexureTable = () => (
        <div style={{ marginTop: '20px' }}>
            <DataGridPro
                rows={annexureData}
                columns={annexureColumns}
                getRowId={(row) => `${row.challan_no}-${row.pan}`}
                // autoHeight
                pagination
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                isRowSelectable={() => false}
                sx={{
                    height: '55vh',
                    marginTop: 2,
                    '& .MuiDataGrid-columnHeaders': {
                        // backgroundColor: '#1976d2',
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textAlign: 'right',
                        zIndex: 1000,
                    },
                    '& .MuiDataGrid-columnHeader': {
                        position: 'relative',
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold',
                        backgroundColor: '#607d8b',
                    },

                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#fff',
                    },
                    "& .MuiDataGrid-sortIcon": {
                        opacity: 'inherit !important',
                    },

                    "& .MuiDataGrid-iconButtonContainer": {
                        visibility: 'visible',
                    },
                    '& .MuiDataGrid-menuIconButton': {
                        opacity: '1 !important',
                        visibility: 'visible !important',
                        display: 'flex !important',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        '& .MuiDataGrid-columnHeader': {
                            '& .MuiDataGrid-menuIconButton': {
                                display: 'flex !important',
                                visibility: 'visible !important',
                                opacity: '1 !important',
                            },
                        },
                    },
                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .MuiDataGrid-cell': {
                        padding: '8px',
                        textAlign: 'center',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f0f0f0',
                    },
                    '& .MuiCheckbox-root': {
                        color: '#1976d2',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#d3e3fc',
                        cursor: 'pointer'
                    },
                }}
            />
        </div>
    );

    return (
        <>
            <Box position="relative" mb={1}>
                <Typography
                    variant="h6"
                    align="center"
                    sx={{
                        fontWeight: 700,
                        letterSpacing: 1,
                        textTransform: 'uppercase',
                    }}
                >
                    26Q Filing ({localStorage.getItem('financial_year_26Q')} {localStorage.getItem('quarter_26Q')})
                </Typography>

                {activeFormStep !== 0 && (
                    <Button
                        variant="outlined"
                        endIcon={
                            <img
                                src={excelIconImage}
                                alt="Excel"
                                style={{ width: 20, height: 20 }}
                            />
                        }
                        color="success"
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                        onClick={handleDownloadReport}
                    >
                        Export
                    </Button>
                )}
            </Box>





            {/* Content */}
            <Box sx={{ mt: 2 }}>
                {activeFormStep === 0 && FormDetails()}
                {activeFormStep === 1 && <ChallanTable />}
                {activeFormStep === 2 && <AnnexureTable />}
            </Box>

            <Stack direction="row" spacing={2} sx={{ mt: 3, justifyContent: 'space-between', alignItems: 'center' }}>
                {activeFormStep !== 0 ? (
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handleBack}
                        sx={{
                            textTransform: 'none',
                            px: 2,
                            py: 0.8,
                            fontSize: '0.85rem',
                            borderRadius: '8px',
                            borderColor: 'primary.main',
                            color: 'primary.main',
                            fontWeight: 500,
                            minWidth: 90,
                            '&:hover': {
                                borderColor: 'primary.dark',
                                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                            },
                        }}
                    >
                        Back
                    </Button>
                ) : (
                    <Box />
                )}

                <Box sx={{ flex: 1 }} />

                {activeFormStep !== steps.length - 1 && activeFormStep !== 0 && (
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleNext}
                        sx={{
                            textTransform: 'none',
                            px: 2,
                            py: 0.8,
                            fontSize: '0.85rem',
                            borderRadius: '8px',
                            fontWeight: 500,
                            minWidth: 90,
                            boxShadow: 'none',
                            backgroundColor: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            },
                        }}
                    >
                        Next
                    </Button>
                )}
                {activeFormStep === steps.length - 1 && (
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleFile26Q}
                        sx={{
                            textTransform: 'none',
                            px: 2,
                            py: 0.8,
                            fontSize: '0.85rem',
                            borderRadius: '8px',
                            fontWeight: 500,
                            minWidth: 90,
                            boxShadow: 'none',
                            backgroundColor: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            },
                        }}
                    >
                        File 26Q
                    </Button>
                )}

            </Stack>
        </>
    );
};

export default Form26QFiling;